module.exports = __webpack_public_path__ + "img/borrower_benefit_scoreandmore_mobile.e740b02b.jpg";